import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Hourglass, AlertTriangle, MessageCircle } from "lucide-react";
import { UPGRADE_WA } from "@/lib/pricing";

export const FreeLaunchCountdown = () => {
  const [st, setSt] = useState(null);
  useEffect(() => {
    const load = () => api.get("/company/status").then((r) => setSt(r.data)).catch(() => {});
    load();
    window.addEventListener("mc-status-changed", load);
    return () => window.removeEventListener("mc-status-changed", load);
  }, []);

  if (!st) return null;

  if (st.free_launch_ended) {
    return (
      <div className="flex flex-wrap items-center gap-3 rounded-2xl border-2 border-[#FF3B30]/60 bg-[#FF3B30]/10 px-5 py-4 mb-6" data-testid="free-launch-ended-banner">
        <AlertTriangle className="w-6 h-6 text-[#FF3B30] shrink-0" />
        <div className="flex-1 min-w-[200px]">
          <div className="font-heading font-extrabold text-lg text-white">Your free month has ended</div>
          <div className="text-sm text-[#C9CFDA]">Upgrade to keep unlocking crew contacts and downloading CVs.</div>
        </div>
        <Button asChild className="rounded-full bg-[#25D366] hover:bg-[#1da851] text-black font-bold gap-2" data-testid="free-launch-upgrade-btn">
          <a href={UPGRADE_WA} target="_blank" rel="noreferrer"><MessageCircle className="w-4 h-4" /> Upgrade — contact us</a>
        </Button>
      </div>
    );
  }

  if (!st.subscribed || !st.free_launch) return null;
  const d = st.free_launch_days_left;
  return (
    <div className="flex items-center gap-4 rounded-2xl border-2 border-[#25D366]/60 bg-[#25D366]/10 px-5 py-4 mb-6" data-testid="free-launch-countdown">
      <div className="font-heading font-extrabold text-4xl sm:text-5xl text-[#25D366] leading-none" data-testid="free-launch-days-left">{d}</div>
      <div>
        <div className="font-heading font-extrabold text-lg text-white">{d} day{d === 1 ? "" : "s"} left in your free month</div>
        <div className="text-sm text-[#C9CFDA] flex items-center gap-1"><Hourglass className="w-3.5 h-3.5" /> Free until {String(st.subscription_expiry).slice(0, 10)}</div>
      </div>
    </div>
  );
};
